import * as React from "react";
var CheckMarkIcon = function CheckMarkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M390.4 870.4c-41.6 0-86.4-16-112-48l-256-268.8c-35.2-32-25.6-89.6 16-121.6 35.2-25.6 86.4-25.6 118.4 9.6L387.2 688l480-499.2c35.2-32 92.8-32 128 9.6 35.2 32 35.2 83.2 9.6 115.2L499.2 819.2c-25.6 35.2-67.2 51.2-108.8 51.2z",
    style: {
      fill: props.color
    }
  }));
};
export default CheckMarkIcon;